import dynamic from 'next/dynamic'

import { RenderOnFirstInteraction } from '@/components/RenderOnFirstInteraction'

const DynamicUseResetGeneratorForms = dynamic(() =>
	import('./UseResetGeneratorForms').then((mod) => mod.UseResetGeneratorForms),
)
export const LazyUseResetGeneratorForms = () => (
	<RenderOnFirstInteraction element={<DynamicUseResetGeneratorForms />} />
)
